var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2395 4260 c-773 -88 -1381 -652 -1516 -1406 -30 -167 -30 -421 0 -588 183 -1022 1236 -1653 2213 -1326 582 194 1013 676 1138 1272 143 678 -145 1379 -725 1767 -266 178 -567 274 -897 285 -73 3 -169 1 -213 -4z m472 -239 c292 -65 544 -203 749 -411 207 -209 341 -455 407 -748 18 -82 21 -128 21 -302 0 -174 -3 -220 -21 -302 -133 -592 -571 -1029 -1161 -1160 -81 -18 -130 -22 -297 -22 -224 -1 -291 9 -475 70 -234 78 -402 183 -586 368 -219 220 -342 450 -410 766 -27 121 -27 439 0 560 69 320 191 546 415 771 249 248 476 361 871 433 14 2 108 3 210 1 141 -2 207 -8 277 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 3251 c-177 -58 -257 -260 -165 -417 100 -171 348 -187 466 -30 44 58 59 104 59 182 -1 101 -62 198 -155 246 -43 23 -161 34 -205 19z m133 -233 c22 -27 22 -49 -4 -82 -52 -66 -148 1 -108 75 22 42 79 45 112 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3190 3251 c-117 -36 -199 -146 -200 -267 0 -166 119 -288 280 -288 232 0 365 261 228 449 -33 46 -96 91 -147 105 -41 11 -124 12 -161 1z m133 -233 c23 -27 22 -63 -4 -89 -46 -46 -135 7 -113 68 18 53 80 64 117 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433 1989 c-220 -26 -454 -130 -608 -272 l-50 -46 74 -74 74 -75 58 48 c341 284 827 281 1165 -6 l51 -43 74 75 74 75 -50 46 c-116 106 -294 202 -453 243 -143 36 -271 45 -409 29z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.0412469625707ced1db50f00e0c6163f.svg";
export { ForwardRef as ReactComponent };